<template>
  <div style="background-color: #F9FBFD;">
    <div class="About_header">
      <div class="About_header_img">
        <img src="../../src/assets/banner-1.png" alt="" srcset="">
      </div>
      <div class="About_header_title" id="About_header_title">
        <div class="About_header_box"
          :style="index == titIndex || Number(index) + 3 == titIndex  ? 'color: #1D2B3E;' : ''"
          v-for="(item,index) in titleList" :key="index" @click="handleSelect(index)">
          <span>{{item.name}}</span>
        </div>
        <div class="About_header_box" @click="bandus">
          <span>联系我们</span>
        </div>
        <div class="tab-activation-item" :style="{
        		left: (newleft + 338)+'px',
        	}"></div>
        <div class="About_header_title_board">
          <div style="font-size: 24px;color: #ffffff;margin-bottom: 7px;">ABOUT US</div>
          <div style="width: 48px;height: 3px;background-color: #ffffff;margin-bottom: 5px;"></div>
          <div style="font-size: 24px;color: #ffffff;">关于我们</div>
        </div>
      </div>
      <div v-if="titIndex == 0">
        <div class="w">
          <div class="About-information">
            <div class="About-information-title">公司简介/Company Profile</div>
            <div class="About-information-box">
              <div class="About-information-box-box"></div>
              <div class="About-information-box-img">
                <img src="../assets/profile.png" alt="">
              </div>
              <div class="About-information-box-content">
				  全国SP社区分享平台（智教荟）是在中国医药教育协会SP课题组支持下筹建的全国标准化病人（SP）医学教育项目交流、人才互动和教学互助平台，由协会会员单位——武汉创智空间科技有限公司托管运行，服务与全国医科院校和医疗机构。
                武汉创智空间科技有限公司位于武汉市硚口区同心健康服务产业园，是一家集研究、产品开发、销售于一体的创新型科技公司。公司员工来自教育、医学、信息技术等专业，深耕医学教育行业十余年。公司以全国知名的医学教育领域专家为桥梁，致力于构建基于形成性评价的智能化医学教育平台、建设全方位标准化病人（SP）服务方案，推动医学教育全流程改革的智能化发展。
              </div>
            </div>
          </div>
          <div class="About-brief">
            <div class="About-brief-title">CMEA-SP简介</div>
            <div class="About-brief-box">
              武汉创智空间科技有限公司担任中国医药教育协会SP课题组全国范围的学术推广和技术支持工作。旨在指导和服务于全国SP医学教学、考试和大赛，提供标准化的SP项目管理体系与服务内容，促进全国医学和健康教育事业发展及相关人才培养工作
            </div>
          </div>
        </div>
      </div>
      <div v-if="titIndex == 1">
        <div class="w">
          <div class="About-teacher">
            <div class="About-teacher-box" v-for="(item, key) in queryInfolist" :key="key">
              <div class="About-teacher-box-img">
                <el-image style="width: 200px; height: 300px;" :src="item.faceImageUrl" fit="cover">
                  <div slot="error" class="image-slot">
                    <img src="../assets/noimg.png" alt="">
                  </div>
                </el-image>
              </div>
              <div class="About-teacher-box-box ql-snow ql-editor" id="editor">
                <span>{{item.name}}</span>
                <div>
                  <!-- <span class="About-teacher-box-box-button">武汉</span> -->
                  <span class="About-teacher-box-box-button" style="margin-top:10px;">{{item.company}}</span>
                </div>
                <span v-html="item.introduction"></span>
              </div>
            </div>

          </div>
          <div class="news-footer">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryInfo.pageSize"
              :current-page="queryInfo.pageNum" @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>

        </div>
      </div>
      <div v-if="titIndex == 2">
        <div class="w" style="padding-bottom: 80px;">
          <div class="About-example">
            <div class="About-example-img">
              <img src="../assets/zho.png" alt="">
            </div>
            <div class="About-example-box">
              <div>武汉大学中南医院 </div>
              <div>
                <P>成立时间：2023年4月</P>
                <P>负责人：雷红</P>
                <P>主要任务：“湖北省SP教学示范项目”首个基地</P>
              </div>
              <!-- <div>
                负责人：雷红
              </div>
              <div>主要任务：“湖北省SP教学示范项目”首个基地
              </div> -->
            </div>
          </div>
          <!-- <div class="About-example">
            <div class="About-example-img1"></div>
            <div class="About-example-box1">
              <div>协和SP人才示范中心</div>
              <div>
                协和SP人才示范中心建成于2000年。详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍
              </div>
              <div><span
                  style="width: 50px; height: 3px;background: #395172;display: inline-block;margin-right: 10px;"></span>负责人
              </div>
            </div>
          </div>
          <div class="About-example">
            <div class="About-example-img"></div>
            <div class="About-example-box">
              <div>协和SP人才示范中心</div>
              <div>
                协和SP人才示范中心建成于2000年。详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍详细介绍
              </div>
              <div><span
                  style="width: 50px; height: 3px;background: #395172;display: inline-block;margin-right: 10px;"></span>负责人
              </div>
            </div>
          </div>
 -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        titleList: [{
            name: '关于我们',
            value: 0
          },
          {
            name: '专家团队',
            value: 1
          },
          {
            name: 'SP教学中心',
            value: 2
          }
        ],
        titIndex: 0,
        newwidth: 0,
        newheight: 4,
        newleft: 0,
        queryInfo: {
          pageNum: 1,
          pageSize: 4,
          name: '',
          type: 1
        },
        queryInfolist: [],
        total: 0

      }
    },


    watch: {
      titIndex(newVal) {
        this.titIndex = newVal
        this.$nextTick(() => {
          this.Aboutinit()
        })
      },
    },
    created() {
      if (this.$route.query.place) {
        this.titIndex = this.$route.query.place
      } else {
        this.titIndex = 0
      }
      this.getofficialteacherslist()

    },
    methods: {
      handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize
        this.getofficialteacherslist()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pageNum = newPage
        this.getofficialteacherslist()
      },
      async getofficialteacherslist() {
        let res = await this.$Http.officialteacherslist(this.queryInfo)
        if (res.data.result != 0) {
          this.$message.error(res.data.msg)
          return
        }
        this.queryInfolist = res.data.data.list
        this.total = res.data.data.total
      },
      bandus() {
        window.scrollTo(0, 50000);
      },
      handleSelect(index) {
        this.titIndex = index
        this.$router.push({
          query: {
            place: this.titIndex
          }
        })
      },
      Aboutinit() {
        let data = document.getElementsByClassName('About_header_box')
        if (data.length) {
          let arr = []
          for (var i = 0; i < data.length; i++) {
            arr.push(data[i].clientWidth)
          }
          let titIndexnum = 0
          if (Number(this.titIndex) > 2) {
            this.newwidth = arr[Number(this.titIndex) - 3]
            titIndexnum = Number(this.titIndex) - 3
          } else {
            this.newwidth = arr[this.titIndex]
            titIndexnum = this.titIndex
          }

          this.newleft = arr.slice(0, titIndexnum).reduce((num, item) => {
            return num + item + 70
          }, 0)
          document.getElementById('About_header_title').scrollLeft = this.newleft - arr[this.titIndex] / 2;
        }
      }

    },
    mounted() {
      this.Aboutinit()
    },
  }
</script>
<style lang="less" scoped>
  .w {
    width: 1200px !important;
    margin: 0 auto;
  }

  .About_header {
    width: 100%;
    position: relative;
  }

  .About_header_img {
    width: 100%;

    img {
      width: 100%;
    }

  }

  .About_header_title {
    width: 1200px !important;
    margin: 0 auto;
    display: flex;
    height: 85px;
    padding-left: 348px;
    box-sizing: border-box;
    align-items: center;
    position: relative;
    background-color: #ffffff;
  }

  .About_header_title_board {
    position: absolute;
    left: 0;
    top: -84px;
    width: 269px;
    height: 169px;
    background-color: #1A7BFC;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 27px;
  }

  .About_header_box {
    display: inline-block;
    color: #808080;
    font-size: 16px;
    cursor: pointer;
    margin-right: 70px;
    z-index: 99;
  }

  .tab-activation-item {
    background: #1D2B3E;
    position: absolute;
    top: 41px;
    left: 0;
    z-index: 9;
    transition: all 0.3s linear;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .About-information {
    margin-top: 80px;
    width: 100%;
  }

  .About-information-title {
    width: 100%;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
  }

  .About-information-box {
    margin-top: 50px;
    width: 100%;
    height: 487px;
    position: relative;
  }

  .About-information-box-box {
    width: 191px;
    height: 168px;
    background: #1D2B3E;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }

  .About-information-box-img {
    width: 467px;
    height: 467px;
    position: absolute;
    top: 20px;
    left: 23px;
    z-index: 20;

    img {
      width: 100%;
    }
  }

  .About-information-box-content {
    width: 824px;
    max-height: 336px;
    position: absolute;
    top: 115px;
    left: 248px;
    z-index: 30;
    padding: 20px 61px;
    background-color: #ffffff;
    box-sizing: border-box;
    color: #8693A4;
    font-size: 16px;
    letter-spacing: 1px;
    line-height: 40px;
  }

  .About-brief {
    width: 100%;
    margin-top: 132px;
    padding-bottom: 80px;
  }

  .About-brief-title {
    width: 100%;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
  }

  .About-brief-box {
    width: 982px;
    height: 100%;
    font-size: 16px;
    color: #8693A4;
    margin: 51px auto 0;
    letter-spacing: 1px;
    line-height: 48px;
    text-align: center;
  }

  .About-teacher {
    width: 100%;
    height: 100%;
    padding: 80px 0;
    overflow: hidden;
    box-sizing: border-box;
  }

  .About-teacher-box {
    width: 1200px;
    // height: 206px;
    box-sizing: border-box;

    display: flex;
    margin-bottom: 80px;
    flex-direction: row;
  }

  .About-teacher-box:nth-child(2n) {
    flex-direction: row-reverse;
  }

  .About-teacher-box:nth-child(2n) {
    margin-right: 0;
  }

  .About-teacher-box-img {
    width: 200px;
    height: 300px;

    image {
      width: 100%;
      height: 100%;
    }
  }

  .About-teacher-box-box {
    width: calc(100% - 200px);
    min-height: 428px;
    padding: 40px 50px;
    margin-top: 36px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    background-color: #FFFFFF;
    line-height: 24px;
    position: relative;
  }

  .About-teacher-box-box span:nth-child(1) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 32px;
    font-weight: normal;
    color: #395172;
  }

  .About-teacher-box-box-button {
    display: inline-block;
    padding: 2px 5px;
    background: rgba(134, 147, 164, 0.1);
    font-size: 12px !important;
    border-radius: 2px;
    margin-right: 11px;
    background: rgba(26, 123, 252, 0.2);
    color: #1A7BFC !important;
  }

  .About-teacher-box-box span:nth-child(3) {
    font-family: Alibaba PuHuiTi 2.0;
    font-size: 14px;
    font-weight: normal;
    color: #8693A4;
    // overflow: hidden;
    // -webkit-line-clamp: 3;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
  }

  .About-teacher-box-box span:nth-child(4) {
    position: absolute;
    top: 52px;
    right: 50px;
    font-size: 60px;
    color: #395172;
    opacity: 0.1;
    font-weight: 600;
  }

  .news-footer {
    width: 100%;
    padding: 50px;
    box-sizing: border-box;
    text-align: center;
  }

  .About-example {
    margin-top: 80px;
    width: 100%;
    height: 500px;
    position: relative;
  }

  .About-example-img {
    position: absolute;
    width: 500px;
    height: 500px;
    background-color: red;
    top: 0;
    right: 0;
    z-index: 10;
    overflow: hidden;

    img {
      height: 100%;
    }
  }

  .About-example-img1 {
    position: absolute;
    width: 500px;
    height: 500px;
    top: 0;
    left: 0;
    z-index: 10;
  }



  .About-example-box {
    position: absolute;
    width: 812px;
    // height: 385px;
    background-color: #ffffff;
    top: 70px;
    left: 0;
    z-index: 20;
    padding: 43px 57px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
  }

  .About-example-box1 {
    position: absolute;
    width: 812px;
    height: 385px;
    background-color: #ffffff;
    top: 70px;
    right: 0;
    z-index: 20;
    padding: 43px 57px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .About-example-box div:nth-child(1) {
    font-size: 30px;
    font-weight: 600;
    color: #395172;
  }

  .About-example-box div:nth-child(2) {
    font-size: 20px;
    color: #8693A4;
    line-height: 22px;
  }

  .About-example-box div:nth-child(3) {
    font-size: 20px;
    color: #8693A4;
    line-height: 48px;
  }

  .About-example-box div:nth-child(4) {
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #395172;
  }

  /deep/ .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 128px;
    }
  }
</style>
